<form>
  <div class="modal-header">
    <h4 class="modal-title">
      {{'corruptArticlesPopUp.title' | translate}}
    </h4>
  </div>
  <div class="modal-body pt-0">
    <div class="modal-body-inner">
      <p id="corrupt-articles-description" class="mb-3">{{ 'corruptArticlesPopUp.label.text' | translate }}</p>
      <table class="article-list" aria-describedby="corrupt-articles-description">
        <thead>
          <tr>
            <th class="article-no">{{ 'corruptArticlesPopUp.label.articleNo' | translate }}</th>
            <th>{{ 'corruptArticlesPopUp.label.description' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let corruptArticle of corruptArticles ">
            <td class="article-no">{{ corruptArticle.articleNo }}</td>
            <td>{{ corruptArticle.description }}</td>
          </tr>
        </tbody>
      </table>
      <p class="mt-3">{{ 'corruptArticlesPopUp.label.question' | translate }}</p>
    </div>
  </div>
  <div class="modal-footer">
    <button #cancelButton
            type="button"
            id="button-cancel"
            class="btn btn-secondary btn-cancel"
            (click)="cancel()">
      {{'global.label.cancel' | translate}}
    </button>
    <button #removeButton
            id="button-remove"
            class="btn btn-primary btn-forward"
            (click)="remove()">
            {{'global.label.remove' | translate}}
    </button>
  </div>
</form>
